import React from "react";
function formatDate(inputDate) {
  const date = new Date(inputDate); // Convert the input to a Date object

  // Define month names
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract date, month, and year
  const day = date.getUTCDate(); // Get the day of the month
  const month = months[date.getUTCMonth()]; // Get the month name
  const year = date.getUTCFullYear(); // Get the year

  // Return formatted string
  return `${day} ${month} ${year}`;
}
export default function ViewAppointmentLayer({ data }) {
  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0">View Job</h5>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 row">
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Client Name
              </label>
              <p id="label_1">{data?.client_name}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Client Phone
              </label>
              <p id="label_1">{data?.phone}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Email Address
              </label>
              <p id="label_1">{data?.email}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Job Cost
              </label>
              <p id="label_1">{data?.job_cost}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Address
              </label>
              <p id="label_1">{data?.address}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                PostCode
              </label>
              <p id="label_1">{data?.postcode}</p>
            </div>
            <div className="col-md-12 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Service Required
              </label>
              <ul id="label_1">
                {data?.service_required.split(",").map((e) => (
                  <li>{e}</li>
                ))}
              </ul>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Status
              </label>
              <p>{data.status}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Assigned By
              </label>
              <p>{data?.assignedBy?.name ? data?.assignedBy?.name : 'N/a'}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Assigned To
              </label>
              <p>{data?.assignedTo?.name ? data?.assignedTo?.name : 'N/a'}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Created at
              </label>
              <p>{formatDate(data.createdAt)}</p>
            </div>
            <div className="col-md-12 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Message
              </label>
              <p>{data?.message}</p>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  );
}
